export default "__VITE_ASSET__tQPlJctb__"